import React from 'react';
import { Box } from '@mui/material';

import { useAppSelector } from '../hooks';

export function ConversionResults() {
  const conversionResults = useAppSelector((state) => state.conversionResults);

  return (
    <Box sx={{ m: 'auto', width: '40%' }}>
      {conversionResults.map((conversionResult) => {
        const numberOfFilesSuccessfullyConverted =
          conversionResult.numberOfFilesSubmitted - conversionResult.failedConversions.length;
        const percentageAsDecimal = numberOfFilesSuccessfullyConverted / conversionResult.numberOfFilesSubmitted;
        const successRate = Math.round(percentageAsDecimal * 100);
        let bgcolor;
        switch (successRate) {
          case 100:
            bgcolor = 'green';
            break;
          case 0:
            bgcolor = 'red';
            break;
          default:
            bgcolor = 'orange';
        }
        const summaryString = `${numberOfFilesSuccessfullyConverted} of ${conversionResult.numberOfFilesSubmitted} (${successRate}%)`;

        const failedConversionElements = conversionResult.failedConversions.map((failedConversion) => (
          <Box key={failedConversion.guid}>
            {'name' in failedConversion && 'fileType' in failedConversion && (
              <Box>{`${failedConversion.name}.${failedConversion.fileType}`}</Box>
            )}
            <Box title={(failedConversion.exception as any).StackTraceString}>
              {(failedConversion.exception as any).Message}
            </Box>
          </Box>
        ));

        let failedConversionSection;
        if (failedConversionElements.length > 0) {
          failedConversionSection = (
            <Box>
              <Box component="span">Failed Conversions</Box>
              {failedConversionElements}
            </Box>
          );
        }

        return (
          <Box key={conversionResult.guid} sx={{ bgcolor, p: 1, m: 1 }}>
            <Box>
              <b>{summaryString}</b>
            </Box>
            {failedConversionSection}
          </Box>
        );
      })}
    </Box>
  );
}
